import { b } from './chunk-IMSWER4T.js';

var o=class extends b{URL="scheduled-imports";async togglePipelineRunningState(r){return (await this._client.post("/scheduled-imports/toggle",{pipelines:r})).data}};

export { o as a };
//# sourceMappingURL=chunk-GIQUXH2L.js.map
//# sourceMappingURL=chunk-GIQUXH2L.js.map